import { Dialog, DialogBody } from '@material-tailwind/react';

const ModalImg = ({ open, handleOpen, foto }) => {
  return (
    <Dialog open={open} handler={handleOpen} className="dark:bg-darkColorBg">
      <DialogBody>
        <img
          alt="nature"
          className={`w-full md:h-[40em] rounded-lg object-contain md:object-cover object-center  lg:object-contain `}
          src={foto}
        />
      </DialogBody>
    </Dialog>
  );
};

export default ModalImg;
